import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "background-image-card"
    }}>{`Background Image Card`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Box
  sx={{
    px: 4,
    py: 6,
    backgroundImage: 'url(https://source.unsplash.com/random/1024x768?sky)',
    backgroundSize: 'cover',
    borderRadius: 8,
    color: 'white',
    bg: 'gray',
  }}>
  <Heading
    textAlign='center'
    fontSize={[ 5, 6 ]}>
    Background Image
  </Heading>
</Box>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      